import React, {Component} from 'react';
import _ from 'lodash';
import $ from 'jquery';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import renderHTML from 'react-render-html';

export default class InlineEditPositionName extends Component {
  constructor(props){
    super(props)

    this.state = {
      editing: false,
      mode: this.props.mode,
      position_name: this.props.position_name
    }

    this.handleEdit = this.handleEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSetValue = this.handleSetValue.bind(this);
    this.calculateMargin = this.calculateMargin.bind(this);
  }

  componentDidMount(){
    this.calculateMargin();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      mode: nextProps.mode,
      position_name: nextProps.position_name
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.calculateMargin();
  }

  calculateMargin(){
    const { signees_count } = this.props;

    _.times(signees_count, function(n){
      const full_page_width = 604;
      let start_point = 302;
      
      const position_name_width = $(`label#position_of_position_name_${n}`).width(); 
      const fullname_width = $(`label#signee-fullname_${n}`).width();

      if (position_name_width !== undefined && fullname_width !== undefined) {
        const half_fullname_width = fullname_width / 2;
        const half_position_name_width = position_name_width / 2;

        if (half_fullname_width <= half_position_name_width){
          const rest_width = full_page_width - parseInt(position_name_width);
          const diff = half_position_name_width - half_fullname_width;
          start_point = start_point - diff;

          if (start_point > rest_width){
            start_point = rest_width;
          }
        }else{
          const diff = half_fullname_width - half_position_name_width;
          start_point = start_point + diff;
        }

        document.getElementById(`position_of_position_name_${n}`).style.marginLeft = `${start_point}px`;
      }
    });
  }

  handleEdit(){
    this.setState({editing: true})
  }

  handleChange(value){
    this.setState({position_name: value});
  }

  handleSetValue(){
    let { mode, position_name } = this.state;
    this.setState({editing: false}, this.props.handleChange(this.props.signee, mode, position_name));
  }

  stripHTML(text){
    if (_.isEmpty(text)) { return }

    var regex = /(<([^>]+)>)/ig;
    return text.replace(regex, "");
  }

  render(){
    var position_name = this.stripHTML(this.props.position_name);
    return (
      <div className='row'>
        <div className='col-12'>
          <div className='row'>
            <div className='col-12'>

              {this.state.editing ? (
                <div className='row'>
                  <div className='col-10'>
                    <ReactQuill 
                      value={this.state.position_name}
                      onChange={this.handleChange}
                      modules={{toolbar: false}} />
                  </div>
                  <div className='col-2'>
                    <button 
                      type='button' 
                      className='btn btn-sm btn-primary'
                      onClick={this.handleSetValue}>ตกลง</button>
                  </div>
                </div>

              ) : (
                <div>
                  {position_name ? (
                    <div className='pointer' onClick={this.handleEdit}>
                      <label id={`position_of_position_name_${this.props.index}`} className='mb-0 text-center'>
                        {renderHTML(this.props.position_name)}
                      </label>
                    </div>
                  ) : (
                    <div className='pointer text-danger' onClick={this.handleEdit}>
                      <em>ตำแหน่ง</em>
                    </div>
                  )}
                </div>
              )}
              
            </div>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/documents/elements/InlineEditPositionName.js